import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Image } from 'react-bootstrap';
import styles from './SignIn.module.scss';
import { CustomButton } from '../shared/customButton';
import { CustomTextField } from '../shared/customTextField';
import { CustomTextFieldPass } from '../shared/textFieldPass';
import { CustomAlertBox } from '../shared/customAlertBox';
import { signin, getAccountStatus } from '../../services/util/auth';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import Cookies from 'universal-cookie';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';


const SignIn = (props) => {
    const [isLoading, setStatus] = useState(false);
    const [message, setMessage] = useState();
    const [show, setShow] = useState(false);
    const cookies = new Cookies();
    const uname = cookies.get('userName');
    const pass = cookies.get('password');
    const ischecked = (cookies.get('check') === 'true');
    let history = useNavigate();


    const schema = yup.object({
        email: yup.string().email('Invalid email').trim().required('Required'),
        password: yup.string().required('Required')
    });

    const formFocus = () => {
        setShow(false)
    }


    const onSubmit = async (values) => {
        setStatus(true);
        let respond = await signin(values.email, values.password);
        if (respond.success === true) {
            setStatus(false);
            const accountStatus = await getAccountStatus();
            if (accountStatus === 'true') {
                history("/company")
            } else {
                localStorage.setItem('email', values.email);
                history({ pathname: '/email-verify' })
            }

        }
        else {
            setMessage(respond.msg);
            setShow(true)
            setStatus(false)
        }
    }

    useEffect(() => {
        ReactGA.initialize([{
            trackingId: `${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`
        }]);

        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])
    return (
        <div>
            <Helmet>
                <title>Sign In | HireTrace</title>
            </Helmet>
            <Row className={styles.loginBackgroundColor}>
                <Container className={styles.mainBoxContainer}>
                    <div className={styles.loginBox}>
                        <Col sm={{ span: 10, offset: 1 }} className={styles.companyLogoDiv}>
                            <div className={styles.companySecondLogoDiv}>
                                <a href="/" target="_blank" rel="noreferrer">
                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/favicon (1).ico`} rounded fluid className={styles.companyLogo} />
                                </a>
                            </div>

                        </Col>
                        <Container className={styles.innerBoxContainer}>
                            <Row>
                                <Col>
                                    <h3 className={styles.boxTopic}>Welcome back</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h3 className={styles.boxSecondTopic}>Enter your details to login</h3>
                                </Col>
                            </Row>
                            {show === true &&
                                <Row>
                                    <Col sm={12} className={styles.alertColumn}>
                                        {show === true ? (<CustomAlertBox alertBodyText={message} errorMessageId="signIn_errorMsgId" alertType='dangerAlert'/>) : ''}
                                    </Col>
                                </Row>
                            }

                            <Formik
                                validationSchema={schema}
                                onSubmit={(values) => onSubmit(values)}
                                initialValues={{ rememberMe: ischecked ? ischecked : false, email: uname ? uname : '', password: pass ? pass : '' }}>
                                {({
                                    errors,
                                    handleChange,
                                    handleSubmit,
                                    submitCount,
                                    values
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit} onFocus={() => formFocus()}>
                                        <div className={styles.formDivRow}>
                                            <CustomTextField
                                                label="Email*"
                                                classLabel="defaultLabel"
                                                controlId="email"
                                                type="email"
                                                name="email"
                                                placeholder="Enter your email"
                                                value={values.email}
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                validationMessageId="signIn_email_emailValidationMsgId"
                                                errorMessage={errors.email}
                                                isInvalid={submitCount > 0 && !!errors.email}
                                            />
                                            <CustomTextFieldPass
                                                label="Password*"
                                                classLabel="defaultLabel"
                                                controlId="password"
                                                name="password"
                                                placeholder="Enter your password"
                                                value={values.password}
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                errorMessage={errors.password}
                                                validationMessageId="signIn_password_passwordValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.password}
                                            />
                                        </div>
                                        <Row>
                                            <Col className={styles.colAlignLeft}>
                                                <Link to="/forgotpassword" id="signIn_forgotPasswordLinkId" className={styles.forgotPasswordLink}>
                                                    Forgot Password?
                                                </Link>
                                            </Col>
                                        </Row>
                                        <div className={`${styles.formDivRow} ${'mt-3'}`}>

                                            {<CustomButton
                                                buttonType="submit"
                                                id="signIn_submitBtnId"
                                                label="Sign In"
                                                type="primaryBtn"
                                                disabled={isLoading === true ? true : false}
                                                backicon=
                                                {isLoading === true ?
                                                    <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                    : ''
                                                }
                                            />}

                                        </div>
                                    </Form>
                                )}
                            </Formik>

                            <Row>
                                <Col className={styles.signupDiv}>
                                    <div className={styles.signupDivSub}>
                                        <p className={styles.signupText}>Don't have an account?</p>
                                        <Link to="/signup" className={styles.signupLink}>
                                            Sign up
                                        </Link>
                                    </div>
                                </Col>
                            </Row>
                            <Col>
                                <p className={styles.signupBottomMessage}>By clicking the "Sign In" button, you're agreeing to accept </p>
                                <p className={styles.termsPara}><a href="/privacy-policy" target="_blank" rel="noreferrer" className={styles.termsLink}>Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank" rel="noreferrer" className={styles.termsLink}>Terms of Use</a> of HireTrace</p>
                            </Col>
                        </Container>
                    </div>
                </Container>
            </Row>
        </div>
    )
}

export default SignIn